import { createContext } from 'react'
import { ContextMenuConfigType } from '@shared/types'

export const BreadCrumbsContext = createContext<{
  currentPath: string
  contextMenuConfig: ContextMenuConfigType[] | null
}>({
  currentPath: '',
  contextMenuConfig: null,
})

export const BreadCrumbsActionsContext = createContext<{
  setBreadCrumbs: ((currentPath: string, contextMenuConfig: ContextMenuConfigType[]) => void) | null
}>({ setBreadCrumbs: null })
